import TileMap from './TileMap';

export default TileMap;
